<template>
    <nav
        v-if="breadcrumbs.length"
        class="flex-wrap items-center hidden text-xs font-medium leading-5 md:flex"
    >
        <template v-for="(breadcrumb, index) in breadcrumbs">
            <a
                v-if="index !== breadcrumbs.length - 1"
                :key="index"
                :href="breadcrumb.url"
                class="max-w-md text-gray-500 truncate transition duration-150 ease-in-out hover:text-gray-700"
            >{{ breadcrumb.title }}</a>
            <svg
                v-if="index !== breadcrumbs.length - 1"
                :key="index"
                class="flex-shrink-0 w-5 h-5 mx-2 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                />
            </svg>
            <span
                v-else
                :key="index"
                class="max-w-md text-gray-700 truncate"
            >{{ breadcrumb.title }}</span>
        </template>
    </nav>
</template>

<script>

export default {
    name: 'Breadcrumb',
    props: {
        crumbData: {
            type: [Array, Object],
            required: true,
        },
    },
    data () {
        return {
            breadcrumbs: this.crumbData,
        };
    },
};

</script>
